var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.cell.isAnswer ? 'column' : 'containerAnswer',
    _vm.isInFirstRow && 'isInFirstRow',
    'p-0',
  ],attrs:{"data-positiony":_vm.cell.positiony,"data-positionx":_vm.cell.positionx}},[(_vm.cell.isAnswer)?_c('div',{staticClass:"d-flex flex-column p-0 w-100 h-100"},[(!_vm.locked && _vm.font)?_c('div',{staticClass:"symbol",style:('font-family:' + _vm.font)},[_vm._v(" "+_vm._s(_vm.cell.text)+" ")]):_vm._e(),_c('div',{class:[
        ' printElement bg-white',
        { backgroundLocked: _vm.locked },
      ]},[_c('p',[_vm._v(_vm._s(_vm.cell.text))])])]):_c('div',{class:[
      'd-flex align-items-center w-100',
      _vm.isInFirstRow && 'isInFirstRow',
    ]},[_c('div',{staticClass:"h-100 d-flex flex-grow-1"},[_c('div',{staticClass:"w-100 h-100 question text-center px-2 py-3"},[_c('span',[_vm._v(_vm._s(_vm.cell.text))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }